import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { UserServiceService } from "../user-service.service";
import { MatCard } from "@angular/material/card";
import { LazyImgDirective } from "../lazy-img.directive";
import { FormsModule } from "@angular/forms";
import { MatFormField , MatLabel} from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-register-forgot-password",
  templateUrl: "./register-forgot-password.component.html",
  styleUrls: ["./register-forgot-password.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatCard,
    LazyImgDirective,
    FormsModule,
    MatFormField, MatLabel,
    MatInput,
    MatButton
  ]
})
export class RegisterForgotPasswordComponent implements OnInit {
  email1: string = "";
  constructor(private uservice: UserServiceService) {}

  ngOnInit() {}

  sendPwd() {
    console.log(
      "In sendPwd in RegisterForgotPasswordComponent",
      "email:" + this.email1
    );
    this.uservice.sendPwd(this.email1).subscribe(
      data => {
        if (data["success"]) {
          console.log(data);
          alert("Email sent to mail successfully");
        } else {
          console.log(data);
          alert("Mail is not registered");
        }
      },
      err => {
        alert(err.message);
      }
    );
  }
}
